import { StationIssueFilter, USAGE_STATUS } from "@shared/interfaces";
import { produce } from "immer";
import { ActionType, createReducer } from "typesafe-actions";

import { StationStateType } from "../interfaces";
import * as actions from "./actions";

type Action = ActionType<typeof actions>;

const defaultFilter = {
  page: 0,
  limit: 50,
  search: "",
  usage_status: USAGE_STATUS.ALL,
};

const defaultStationIssuesFilter: StationIssueFilter = {
  page: 0,
  limit: 15,
  search: "",
};

export const initialState: StationStateType = {
  stations: [],
  stationsTotal: 0,
  filter: { ...defaultFilter },

  stations_connections: null,
  stations_issues: [],
  total_stations_issues: 0,
  stations_issues_filter: { ...defaultStationIssuesFilter },
  station_raw_data_filter: null,
  station_raw_data: [],
};

const reducer = createReducer<StationStateType, Action>(initialState)
  .handleAction(actions.getStations.success, (state, action) =>
    produce(state, (nextState) => {
      const { rows, count, is_clear } = action.payload;
      nextState.stations = !is_clear ? [...nextState.stations, ...rows] : [...rows];
      nextState.stationsTotal = count;
    }),
  )
  .handleAction(actions.setFilter, (state, action) =>
    produce(state, (nextState) => {
      nextState.filter = action.payload || { ...defaultFilter };
    }),
  )
  .handleAction(actions.clearStations, (state) =>
    produce(state, (nextState) => {
      nextState.stations = [];
      nextState.stationsTotal = 0;
    }),
  )
  .handleAction(actions.createStation.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.stations = [action.payload.station, ...nextState.stations];
    }),
  )
  .handleAction(actions.updateStation.success, (state, action) =>
    produce(state, (nextState) => {
      const stations = nextState.stations;
      const foundStationIndex = stations.findIndex((s) => action.payload.station.id === s.id);
      stations[foundStationIndex] = action.payload.station;

      nextState.stations = [...stations];
    }),
  )
  .handleAction(actions.loadStationsIssues.success, (state, action) =>
    produce(state, (nextState) => {
      const { rows, count, is_clear } = action.payload;

      nextState.stations_issues = !is_clear ? [...nextState.stations_issues, ...rows] : [...rows];
      nextState.total_stations_issues = count;
    }),
  )
  .handleAction(actions.readStationIssue.success, (state, action) =>
    produce(state, (nextState) => {
      const issue = action.payload;

      nextState.stations_issues = state.stations_issues.filter((si) => si.id !== issue.id);
      nextState.total_stations_issues = state.total_stations_issues - 1;
    }),
  )
  .handleAction(actions.setStationsIssuesFilter, (state, action) =>
    produce(state, (nextState) => {
      nextState.stations_issues_filter = action.payload || { ...defaultStationIssuesFilter };
    }),
  )
  .handleAction(actions.getStationsConnections.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.stations_connections = action.payload;
    }),
  )
  .handleAction(actions.getStationRawData.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.station_raw_data = action.payload;
    }),
  )
  .handleAction(actions.setStationViewRawDataFilter, (state, action) =>
    produce(state, (nextState) => {
      nextState.station_raw_data_filter = action.payload;
    }),
  );

export { reducer as StationReducer };
